// extracted by mini-css-extract-plugin
module.exports = {"sticky":"TFoot_sticky__uVfhi"};